import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-welcome-image',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './welcome-image.component.html',
  styleUrl: './welcome-image.component.scss',
})
export class WelcomeImageComponent {
  constructor(private translate: TranslateService) {
    const userLang = 'tr';
    this.translate.use(userLang);
  }

  currentYear: number = new Date().getFullYear();
}
